// Eager-safe entry point: the tokens and i18n module an app root needs, without the form builder itself.
export { FORM_FLYER_BRANDING_TOKEN } from './lib/interface';
export { TranslationModule } from './lib/translation-module';
